export default __webpack_public_path__ + "static/media/ship_white.ea43314a.svg";